module.exports = __webpack_public_path__ + "static/img/3110-2.5ff88f0b.jpg";